import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function RangeValidator(
  minValue: number,
  maxValue: number,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as number;
    if (control.value === null || control.value === undefined) {
      return null; // Don't validate empty values
    }

    return value >= minValue && value <= maxValue
      ? null
      : { range: { min: minValue, max: maxValue, value: value } };
  };
}
